/**
 * **Ist das die Rueckfrage zur Qualifikation -- und nicht der Riegel?**
 * (Migration 0230, Entscheidung E3/E17 vom 04.10.2026)
 *
 * Steht der Betrieb auf "warnen", antwortet die API beim Einplanen eines
 * Bedieners ohne gueltigen Schein `409 belegung.qualifikation_*`; dann gibt
 * es "Trotzdem einplanen". Bei "sperren" kommt derselbe Schluessel mit `422`
 * -- dann bleibt es beim Satz.
 *
 * Gefragt wird nach der Form (`status`, `schluessel`) und nicht nach der
 * Klasse `Fehler`: So laesst es sich ohne den Klienten pruefen.
 */
export function istQualifikationsfrage(fehler: unknown): fehler is { status: number; schluessel: string } {
  if (typeof fehler !== "object" || fehler === null) return false;
  const f = fehler as { status?: unknown; schluessel?: unknown };
  return f.status === 409 && typeof f.schluessel === "string"
    && f.schluessel.startsWith("belegung.qualifikation_");
}
